/** @file       sidenav.jsx
 *  @author     Alex Huctwith <alex@kingsds.network>
 *
 *  @date       April 2022
 *
 *              Side navbar component included from layout.js for navigating between pages
 */

import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { LoginOperations } from '@/features/auth';

import './SideNav.css';

const { VITE_ASSETS_PATH } = import.meta.env;

const isLinkActive = ({ isActive }) => isActive ? 'active' : '';

const navItems = [{
  name: 'about',
  icon: `${VITE_ASSETS_PATH}/icons/about.svg#about`,
  translationKey: 'about',
  url: '/about',
}, {
  name: 'accounts',
  icon: `${VITE_ASSETS_PATH}/icons/accounts.svg#accounts`,
  translationKey: 'accounts',
  url: '/accounts',
}, {
  name: 'worker',
  icon: `${VITE_ASSETS_PATH}/icons/worker.svg#worker`,
  translationKey: 'worker',
  url: '/worker',
}, {
  name: 'user',
  icon: `${VITE_ASSETS_PATH}/icons/user-settings.svg#user`,
  translationKey: 'user_settings',
  url: '/user',
}];

function NavItemList()
{
  const { t } = useTranslation();
  return (
    <>
      {navItems.map(({ name, icon, translationKey, url }) => (
        <li key={name}>
          <NavLink className={isLinkActive} to={url} data-name={name}>
            <svg>
              <title>{t(translationKey)} icon</title>
              <use xlinkHref={icon} />
            </svg>
            <span>{t(translationKey)}</span>
          </NavLink>
        </li>
      ))}
    </>
  );
}

/**
 * Renders the side navbar.
 *
 * @param   {object}      props          The component's properties.
 * @param   {boolean}     props.isOpen   Open or close the component.
 * @param   {function}    props.closeNav Event handler called when the component closes.
 * @returns {JSX.Element}                The rendered component.
 */
export const SideNav = ({ isOpen, closeNav }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={`nav-overlay ${isOpen ? 'nav-open':''}`} onClick={closeNav}></div>
      <nav id="sidebar" className={isOpen ? 'opened' : ''}>
        {/* Grouping in div for flex box positioning. */}
        <div className="sidebar-links">
          <button data-reset className="close-menu" onClick={closeNav}>
            <img src={`${VITE_ASSETS_PATH}/icons/close.svg`} alt={t('close_menu')} />
          </button>
          <NavLink to="/" reloadDocument>
            <img src={`${VITE_ASSETS_PATH}/img/logo-banner.png`} alt="DCP" className="logo" />
          </NavLink>
          <ul className="bottomBorder">
            <NavItemList />
            {/* <li> */}
            {/*   <NavLink className={isLinkActive} to="/hello"> */}
            {/*     <svg> */}
            {/*       <use xlinkHref={`${VITE_ASSETS_PATH}/icons/dcc.svg#dcc`}></use> */}
            {/*     </svg> */}
            {/*     <span>Hello</span> */}
            {/*   </NavLink> */}
            {/* </li> */}
            <li>
              <button data-reset onClick={() => LoginOperations.handleLogout()}>
                <svg>
                  <use xlinkHref={`${VITE_ASSETS_PATH}/icons/log-out.svg#logout`} />
                </svg>
                <span>{t('log_out')}</span>
              </button>
            </li>
          </ul>
        </div>
        <div className="powered-by-dcp">
          <span>{t('powered_by')}</span>
          <img src={`${VITE_ASSETS_PATH}/img/c-shield.png`} alt="DCP" />
        </div>
      </nav>
    </>
  );
};
